import { motion } from "framer-motion";

const LoaderOverlay = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backdropFilter: "blur(3px)",
        background: "rgba(255,255,255,0.6)",
        zIndex: 99,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          border: "5px solid",
          borderImageSlice: 1,
          borderWidth: "5px",
          borderImageSource:
            "conic-gradient(rgb(102, 126, 234), rgb(118, 75, 162), rgb(240, 147, 251))",
        }}
      ></motion.div>
    </motion.div>
  );
};

export default LoaderOverlay;
